
import React, { useEffect, useState } from 'react';

interface Leaf {
  id: number;
  left: string;
  delay: string;
  duration: string;
  size: string;
  rotation: string;
  type: number;
}

const LeafFall: React.FC = () => {
  const [leaves, setLeaves] = useState<Leaf[]>([]);

  useEffect(() => {
    const leafCount = 10;
    const newLeaves: Leaf[] = [];
    for (let i = 0; i < leafCount; i++) {
      newLeaves.push({
        id: i,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 20}s`,
        duration: `${10 + Math.random() * 15}s`,
        size: `${10 + Math.random() * 15}px`,
        rotation: `${Math.random() * 360}deg`,
        type: Math.floor(Math.random() * 3),
      });
    }
    setLeaves(newLeaves);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[80] overflow-hidden">
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className="absolute top-[-20px] animate-fall"
          style={{
            left: leaf.left,
            animationDelay: leaf.delay,
            animationDuration: leaf.duration,
          }}
        >
          <svg
            width={leaf.size}
            height={leaf.size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: `rotate(${leaf.rotation})` }}
            className="opacity-40"
          >
            {leaf.type === 0 && (
              <path
                d="M12 2C12 2 4 8 4 14C4 18.4183 7.58172 22 12 22C16.4183 22 20 18.4183 20 14C20 8 12 2 12 2Z"
                fill="#2D5A27"
              />
            )}
            {leaf.type === 1 && (
              <path
                d="M2 12C2 12 8 4 14 4C18.4183 4 22 7.58172 22 12C22 16.4183 18.4183 20 14 20C8 20 2 12 2 12Z"
                fill="#3E6B34"
              />
            )}
            {leaf.type === 2 && (
              <path
                d="M12 22C12 22 20 14 20 8C20 3.58172 16.4183 0 12 0C7.58172 0 4 3.58172 4 8C4 14 12 22 12 22Z"
                fill="#4A7C44"
              />
            )}
          </svg>
        </div>
      ))}
    </div>
  );
};

export default LeafFall;
